// import ProjectLayout from "@/src-refactor/modules/shared/components/project-layout/ProjectLayout";
import ProjectLayout from "@/src-refactor/modules/shared/components/project-layout/ProjectLayout";
interface IPrivateLayout {
  children: JSX.Element;
}

function PrivateLayout(props: IPrivateLayout) {
  return <ProjectLayout>{props.children}</ProjectLayout>;
}

export default PrivateLayout;
